<template>
  <el-row type="flex" align="middle">
    <el-image v-if="value[iconLabel]" style="width: 20px; height: 20px; margin-right: 5px" :src="value[iconLabel]" />{{ value[label] }}
  </el-row>
</template>

<script>
export default {
  name: 'shop-info',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: 'title',
    },
    iconLabel: {
      type: String,
      default: 'icon',
    },
  },
};
</script>
